// Cross-subdomain login-presence flag.
//
// The auth token itself stays in per-origin localStorage and is never placed
// here. This is a strictly-necessary *functional* cookie: a boolean flag whose
// only job is to let the static marketing site (www.spellstudy.com) tell a
// logged-in visitor apart from a guest and relabel its "Login" CTA to
// "Go to Dashboard". Because it carries no personal data or credential, it does
// not require cookie-consent under EU ePrivacy / India DPDP.

const FLAG = "ss_auth";
const MAX_AGE = 60 * 60 * 24 * 30; // 30 days

// Share across *.spellstudy.com in production; omit Domain on localhost/dev so
// the cookie still sets locally (browsers reject a Domain that isn't a suffix
// of the current host).
function domainAttr() {
  const host = window.location.hostname;
  return host.endsWith("spellstudy.com") ? "; Domain=.spellstudy.com" : "";
}

function secureAttr() {
  return window.location.protocol === "https:" ? "; Secure" : "";
}

export function setAuthFlag() {
  document.cookie = `${FLAG}=1; Path=/${domainAttr()}; Max-Age=${MAX_AGE}; SameSite=Lax${secureAttr()}`;
}

export function clearAuthFlag() {
  document.cookie = `${FLAG}=; Path=/${domainAttr()}; Max-Age=0; SameSite=Lax${secureAttr()}`;
}
